'use client';
import React from 'react';
import LazyLoad from 'react-lazyload';
import { useConnatixLivestream } from '@benzinga/livestream-hooks';
import Hooks from '@benzinga/hooks';
import { Block } from '../Block';

const ConnatixVideoPlayer = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.ConnatixVideoPlayer };
  }),
);

const ConnatixInitialHeadScript = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.ConnatixInitialHeadScript };
  }),
);

interface ConnatixVideoProps {
  attrs?: {
    data?: {
      non_live_widget: unknown;
    };
  };
  fallback?: React.ReactNode;
}

export const ConnatixLiveBlock: React.FC<ConnatixVideoProps> = ({ attrs, fallback }) => {
  const { assembleLivestream, livestreamData } = useConnatixLivestream();

  Hooks.useEffectDidMount(() => {
    assembleLivestream();
  });

  if (!livestreamData && attrs?.data?.non_live_widget) {
    return <Block block={attrs?.data?.non_live_widget} />;
  } else if (!livestreamData) {
    return fallback ?? null;
  }

  return (
    <div className="block my-4">
      <React.Suspense fallback={<div aria-hidden className="min-h-[170px] w-full" />}>
        <ConnatixInitialHeadScript id={livestreamData.id} />

        <LazyLoad offset={100} once style={{ minHeight: 170, width: '100%' }}>
          <ConnatixVideoPlayer {...livestreamData} />
        </LazyLoad>
      </React.Suspense>
    </div>
  );
};
